import React from 'react';
import HeaderFour from '../../common/header/HeaderFour';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import WelcomeFour from '../../components/section-components/WelcomeFour';
import AwardOne from '../../components/section-components/AwardOne';
import Experiences from '../../components/section-components/Experiences';
import PracticeAreasFour from '../../components/section-components/PracticeAreasFour';
import OurAttorneysFour from '../../components/section-components/OurAttorneysFour';
import Counter from '../../components/section-components/Counter';
import FooterFour from '../../common/footer/FooterFour';

const AboutUsThree = () => {
    return (
        <>
        <HeaderFour />

        <BreadcrumbOne 
            title="About Us 3"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="About Us 3"
        />
        
        <WelcomeFour />
        
        <AwardOne /> 
        
        <Experiences />
        
        <PracticeAreasFour />
        
        <OurAttorneysFour />
        
        <Counter />

        <FooterFour />
        </>
    )
}
    
export default AboutUsThree;